import { addToCartItem } from "@/utils/addTocart"
import { addToCart } from "@/store/features/cartSlice"
import { getFindAStoresResult } from "@/components/FindStore/v1/api"

import {
  addAnalyticsForBuymore,
  addAnalyticsForBathroomDesign,
  addAnalyticsForGetProfessionalClick,
} from "@/components/ProductDetail/v3/ProductDetailView/analytics/analytics"
import { showPreviewCart, showToast } from "@/store/features/genericSlice"
import { isMobile } from "react-device-detect"

import { store } from "@/store"

export const getStoreUrl = data => {
  const { findStoreUtilityDetails, shortendPagePath, bpNumber } = data
  const bpNumberProcessed = findStoreUtilityDetails[bpNumber]
  const shortUrl = shortendPagePath ?? ""
  const htmlRegExp = new RegExp(".html", "g")
  const htmlRemovedUrl = `${bpNumberProcessed?.replace(htmlRegExp, "")}`
  const shortUrlRegEx = new RegExp(shortUrl, "g")

  return `${htmlRemovedUrl?.replace(shortUrlRegEx, "")}`
}

export const servicesClick = (e, productInfo) => {
  const { target: { href = "", textContent = "" } = {} } = e
  addAnalyticsForBuymore(textContent, href, productInfo)
  window.open(href)
}

export const titleclickhandler = (e, productInfo) => {
  const { target: { href = "", textContent = "" } = {} } = e
  addAnalyticsForBuymore(textContent, href, productInfo)
  window.open(href)
}

export const installserviceClickHandler = (e, productInfo) => {
  const { target: { href = "", textContent = "" } = {} } = e
  addAnalyticsForBathroomDesign(textContent.toLowerCase(), href, productInfo)
}

export const getProsessionalClickHandler = (e, productInfo) => {
  const { target: { href = "", textContent = "" } = {} } = e
  addAnalyticsForGetProfessionalClick(textContent, href, productInfo)
}

export const handleAddToCart = data => {
  const {
    e,
    productServices,
    zipCodeInputVal,
    brandName,
    logger = () => {},
  } = data
  e.preventDefault()
  if (!productServices.length) return
  const item = {
    sku: productServices[0],
    quantity: 1,
    userZipCode: zipCodeInputVal,
    brand: brandName,
  }
  const { quantity } = item
  const itemCountMessage = `${quantity} `
  const ToasterMsg = `${itemCountMessage}`
  addToCartItem([
    {
      ...item,
      isBundle: false,
      backorder: false,
    },
  ])
    .then(response => {
      const body = {
        actions: response,
      }
      store
        .dispatch(addToCart(body))
        .unwrap()
        .then(res => {
          if (res) {
            if (isMobile) {
              store.dispatch(
                showToast({
                  message: ToasterMsg,
                  isVisible: true,
                })
              )
            } else {
              store.dispatch(showPreviewCart())
            }
          }
        })
        .catch(error => {
          logger.error("Error in addToCart dispatch", { error, body })
        })
    })
    .catch(error => {
      logger.error("Error in addToCartItem", { error, item })
    })
}

export const fetchProductsOnDisplayStores = async (data = {}) => {
  const { colorsData = [], findStoresUrl = "", zipCode, brandName } = data
  const skus = colorsData.map(item => item.id) ?? []

  const { data: { info = [] } = {} } = await getFindAStoresResult(
    findStoresUrl,
    zipCode,
    brandName,
    null,
    3,
    "",
    null,
    skus.join(",")
  )
  return info
}

export const getExcludedZipcode = data => {
  const { zipCodeData = [], zipCodeInputVal = "", serviceSku = "" } = data

  const zipCodeInputValPrefix = zipCodeInputVal?.toString().slice(0, 3)
  let zipCodeInExcluded = false

  // excluded_zipcode_prefixes list from authoring
  const excludedZipcodes = zipCodeData.filter(item => {
    if (Object.keys(item)[0] === "excluded_zipcode_prefixes") {
      return Object.keys(item)[0]
    }
  })?.[0]

  const excludedZipcodePrefixes = Object?.values(excludedZipcodes)?.[0]

  // check if the zip code prefix is in the excluded list
  zipCodeInExcluded = excludedZipcodePrefixes.some(prefix => {
    const key = Object.keys(prefix)[0]
    if (key === zipCodeInputValPrefix) {
      return serviceSku
    }
  })

  // check if the service sku is in the excluded sku list
  if (!zipCodeInExcluded) {
    const serviceSkuInExcludedList = excludedZipcodePrefixes.filter(prefix => {
      const values = Object.values(prefix)[0]
      if (values.includes(serviceSku)) {
        return serviceSku
      }
    })
    zipCodeInExcluded = !serviceSkuInExcludedList.length > 0
  }

  return zipCodeInExcluded
}
